/**
 * Utilitário de tracking — dispara FB Pixel + GA4 simultaneamente.
 *
 * @param {string} fbEvent  - Evento padrão FB  (ex: 'AddToCart')
 * @param {string} gaEvent  - Evento GA4        (ex: 'add_to_cart')
 * @param {object} plan     - { id, label, price }
 * @param {object} extra    - Parâmetros adicionais (ex: { transaction_id })
 */
export function trackPlan(fbEvent, gaEvent, plan = {}, extra = {}, opcoesFb = null) {
  const fbParams = {
    content_name:  plan.label  || '',
    content_ids:   [plan.id    || ''],
    content_type:  'product',
    value:         plan.price  || 0,
    currency:      'BRL',
    num_items:     1,
    ...extra,
  };

  const gaParams = {
    currency: 'BRL',
    value:    plan.price || 0,
    items: [{
      item_id:   plan.id    || '',
      item_name: plan.label || '',
      price:     plan.price || 0,
      quantity:  1,
    }],
    ...extra,
  };

  try {
    if (window.fbq) {
      // opcoesFb.eventID: o mesmo event_id que o servidor manda pela Conversions API.
      if (opcoesFb) window.fbq('track', fbEvent, fbParams, opcoesFb);
      else window.fbq('track', fbEvent, fbParams);
    }
  } catch (_) {
    //
  }
  try { if (window.gtag) window.gtag('event', gaEvent, gaParams); } catch (_) {
    //
  }
}

export function eventIdLead(contatoUuid) {
  return `lead-${contatoUuid}`;
}

export function trackLeadMeta(contatoUuid, params = {}) {
  try {
    if (window.fbq) window.fbq('track', 'Lead', params, { eventID: eventIdLead(contatoUuid) });
  } catch (_) {
    //
  }
}

/**
 * Evento simples sem dados de plano (ex: PageView, Contact).
 */
export function trackEvent(fbEvent, gaEvent, params = {}) {
  try { if (window.fbq)  window.fbq('track', fbEvent, params); } catch (_) {
    //
  }
  try { if (window.gtag) window.gtag('event', gaEvent, params); } catch (_) {
    //
  }
}
